<template>
  <div class="content">
    <title-bar :title="$lang.bonus_title4"> </title-bar>
    <div style="margin-left: 10px; margin-right: 10px; margin-top: 10px">
      <img
        src="../../../assets/img/bonus/bonus12.png"
        width="100%"
        style="border-radius: 13px"
      />
    </div>
    <div style="padding: 15px">
      <p class="f-t-16 f-w">{{ $lang.bonus_txt12 }}</p>
      <p class="font-color m-t-10 l-h-20">
        {{ $lang.bonus_txt13 }}
      </p>
      <img
        class="m-t-15"
        src="../../../assets/img/bonus/info-txt.png"
        width="100%"
      />
      <div v-html="$lang.bonus_txt14" class="l-h-20 font-color"></div>
      <van-button
        v-if="!token"
        @click="goToRec"
        size="large"
        class="custom-button m-t-20"
      >
        {{ $lang.bonus_txt15 }}
      </van-button>

      <van-button
        v-if="token"
        @click="goToRev()"
        size="large"
        class="custom-button m-t-20"
        :class="{ active: receiveStatus !== 1 && token && token.length > 1 }"
        :disabled="claiming || (receiveStatus !== 1 && token && token.length > 1)"
      >
        {{ claiming ? ($lang.common_loading || 'Loading...') : $lang.Receber }}
      </van-button>

      <login v-model="showPopup" overlay></login>
    </div>
  </div>
</template>
<script>
import {
  ActivityreceiveRegisterAward,
  ActivitygetRegisterAward
} from '@/api/common'
import {
  failMessage as rewardFailMessage,
  hasRewardIssueProof,
  hasUnavailableMarker,
  isClaimSuccess as rewardClaimSuccess,
  isNeedLogin,
  isOkResponse,
  responseContent
} from '../activity/rewardApi'
export default {
  name: 'FirstRegister',
  components: {},
  data() {
    return {
      showPopup: false,
      receiveStatus: 0,
      claiming: false
    }
  },
  mounted() {
    if (this.token) {
      this.ActivitygetRegisterAward()
    }
  },
  methods: {
    requireLogin() {
      this.showPopup = true
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    isRewardNeedLogin(res) {
      if (isNeedLogin(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (body.need_login === true || body.needLogin === true || [body.status, body.state, body.code, body.errorCode, body.need_login, body.needLogin].some(value => String(value || '').trim().toLowerCase() === 'need_login')) return true
        ;['content', 'data', 'page', 'extra'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasRewardUnavailableMarker(res) {
      if (hasUnavailableMarker(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const values = [
          body.readOnly,
          body.readOnlyMode,
          body.read_only_mode,
          body.readOnlyReward,
          body.read_only_reward,
          body.readOnlyAction,
          body.read_only_action,
          body.read_only,
          body.mock_fallback,
          body.not_implemented,
          body.not_supported,
          body.need_login,
          body.needLogin,
          body.notSupported,
          body.unsupported,
          body.technicalMarker,
          body.technical_marker,
          body.backendFailure,
          body.backend_failure,
          body.technicalError,
          body.technical_error,
          body.technicalException,
          body.technical_exception,
          body.fallback,
          body.dataUnavailable,
          body.data_unavailable,
          body.readUnavailable,
          body.read_unavailable,
          body.writeBlocked,
          body.readBlocked,
          body.read_blocked,
          body.backendBlocked,
          body.backend_blocked,
          body.rewardBackendBlocked,
          body.reward_backend_blocked,
          body.falseProof,
          body.false_proof,
          body.failClosed,
          body.fail_closed,
          body.unimplemented,
          body.failed,
          body.readonly,
          body.notImplemented,
          body.mock,
          body.mockMode,
          body.mock_mode,
          body.mockFallback,
          body.write_blocked,
          body.stub,
          body.msg,
          body.message,
          body.reason,
          body.desc,
          body.description,
          body.errorMsg,
          body.errorMessage,
          body.detail,
          body.readOnlyMessage,
          body.unavailableReason,
          body.status,
          body.state,
          body.result,
          body.code,
          body.errorCode,
          body.paymentStatusUnconfirmed,
          body.payment_status_unconfirmed,
          body.paymentStatus,
          body.payment_status,
          body.rewardStatus,
          body.reward_status
        ]
        const proofValues = [
          body.writeProof,
          body.write_proof,
          body.rewardProof,
          body.reward_proof,
          body.orderProof,
          body.order_proof,
          body.affectedProof,
          body.affected_proof,
          body.serverProof,
          body.server_proof
        ]
        if (proofValues.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return true
        const markers = ['未接入', 'mock', 'mockMode', 'mock_mode', 'fallback', 'dataUnavailable', 'data unavailable', 'data_unavailable', 'readUnavailable', 'read unavailable', 'read_unavailable', 'readBlocked', 'read blocked', 'read_blocked', 'stub', '只读', 'readOnlyMode', 'read_only_mode', 'readOnlyReward', 'read_only_reward', 'readOnlyAction', 'read_only_action', '阻止假成功', 'writeBlocked', 'paymentStatusUnconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'writeProof', 'write_proof', 'writeProof:false', 'write_proof:false', 'falseProof', 'false_proof', 'false proof', 'failClosed', 'fail_closed', 'fail closed', 'backendBlocked', 'rewardBackendBlocked', 'backend_blocked', 'reward_backend_blocked', 'technicalMarker', 'technical_marker', 'technical marker', 'backendFailure', 'backend_failure', 'backend failure', 'technicalException', 'technical_exception', 'technical exception', 'technicalError', 'technical_error', 'technical error', 'not_implemented', 'not_supported', 'not supported', 'need_login', 'need login', 'need-login', 'unsupported', 'unimplemented', 'failed']
        if (values.some((value) => {
          if (value === true || value === 1) return true
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && markers.some((marker) => token.includes(String(marker).toLowerCase()))
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    failMessage(res, fallback) {
      return rewardFailMessage(res, fallback || this.$lang.mc_claim_failed || 'Reward is temporarily unavailable. Please try again later.')
    },
    safeToast(message, icon = 'cross') {
      if (typeof this.$toast === 'function') {
        this.$toast({
          message,
          icon
        })
      }
    },
    showFailToast(res, fallback) {
      this.safeToast(this.failMessage(res, fallback), 'cross')
    },
    isRewardWriteDisabled(content, source) {
      const c = content || {}
      return this.hasRewardUnavailableMarker(source || c) ||
        this.hasRewardUnavailableMarker(c) ||
        c.rewardWritable === false ||
        String(c.rewardWritable).trim().toLowerCase() === 'false' ||
        c.writeEnabled === false ||
        String(c.writeEnabled).trim().toLowerCase() === 'false'
    },
    claimableReceiveStatus(content, source) {
      const status = Number(content && content.receiveStatus) || 0
      return status === 1 && this.isRewardWriteDisabled(content, source) ? 0 : status
    },
    hasRewardWriteProof(res) {
      if (this.hasRewardUnavailableMarker(res)) return false
      const stack = [responseContent(res), res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const proofs = [
          body.writeProof,
          body.write_proof,
          body.affectedProof,
          body.affected_proof,
          body.affectedRowsProof,
          body.affected_rows_proof,
          body.count,
          body.serverProof,
          body.server_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (proofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return false
        const positiveProofs = [
          body.rewardProof,
          body.reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (positiveProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const recordProofs = [
          body.recordNo,
          body.record_no,
          body.recordId,
          body.record_id,
          body.rewardRecordNo,
          body.reward_record_no,
          body.rewardRecordId,
          body.reward_record_id,
          body.receiveRecordNo,
          body.receive_record_no,
          body.receiveRecordId,
          body.receive_record_id,
          body.claimRecordNo,
          body.claim_record_no,
          body.claimRecordId,
          body.claim_record_id
        ]
        const hasRecordProof = recordProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })
        const aliasProofs = [
          body.serverRewardProof,
          body.server_reward_proof
        ]
        if (hasRecordProof && aliasProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const concreteProofs = [
          body.rewardProof,
          body.reward_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (concreteProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasExplicitRewardSuccess(res) {
      const c = responseContent(res)
      return [
        c.receiveSuccess,
        c.claimSuccess,
        c.signSuccess,
        c.paySuccess,
        c.success,
        c.received,
        c.claimed,
        c.signed
      ].some(value => value === true || value === 1 || ['1', 'true', 'success', 'ok'].includes(String(value == null ? '' : value).trim().toLowerCase()))
    },
    isReceiveSuccess(res) {
      return !this.hasRewardUnavailableMarker(res) && rewardClaimSuccess(res) && this.hasExplicitRewardSuccess(res) && (hasRewardIssueProof(res) || this.hasRewardWriteProof(res)) && this.hasRewardWriteProof(res)
    },
    goToRec() {
      this.requireLogin()
    },
    async ActivityreceiveRegisterAward() {
      if (this.claiming) return
      if (!this.token) {
        this.requireLogin()
        return
      }
      this.claiming = true
      try {
        const data = await ActivityreceiveRegisterAward()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (this.isReceiveSuccess(data)) {
          this.ActivitygetRegisterAward()
          this.$toast({
            message: this.$lang.bonus_txt16,
            icon: 'success'
          })
        } else {
          this.showFailToast(data)
        }
      } catch (e) {
        this.showFailToast(e, this.$lang.network_error || '活动请求失败，请稍后重试。')
      } finally {
        this.claiming = false
      }
    },
    goToRev() {
      if (!this.token) {
        this.requireLogin()
        return
      }
      this.ActivityreceiveRegisterAward()
    },
    async ActivitygetRegisterAward() {
      try {
        const data = await ActivitygetRegisterAward()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (isOkResponse(data)) {
          const content = responseContent(data)
          this.receiveStatus = this.claimableReceiveStatus(content, data)
        } else {
          this.showFailToast(data)
        }
      } catch (e) {
        this.showFailToast(e, this.$lang.network_error || '活动请求失败，请稍后重试。')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.info-item {
  border: 1px solid #d9d9d9;
  p {
    width: 33%;
  }
}
.active {
  // box-shadow: 0 4px 1px #4a4a4a !important; /* 阴影效果 */
  background: #9b9b9b !important;
  border-bottom: 0px solid #494949 !important;
}
</style>
